// Person oder Organisation als Symbol; die Art steht daneben immer als Text.
// Geteilt zwischen Befehlspalette und (ab Slice 4b) Kontaktkopf.

import type { ReactElement } from 'react';

export function TypSymbol({ organisation, groesse = 28 }: { readonly organisation: boolean; readonly groesse?: number }): ReactElement {
  return (
    <svg viewBox="0 0 24 24" width={groesse} height={groesse} aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      {organisation ? (
        <path d="M4 20.5V5.5l8-2v17M12 8.5l8 2.5v9.5M2.5 20.5h19M7 8h2M7 11.5h2M7 15h2M15 13.5h2M15 17h2" />
      ) : (
        <>
          <circle cx="12" cy="8" r="3.6" />
          <path d="M4.5 20c.9-3.8 3.9-5.8 7.5-5.8s6.6 2 7.5 5.8" />
        </>
      )}
    </svg>
  );
}
